.listItemIcon {
  color: inherit;
}
